import { Box, Stack, Typography, } from '@mui/material';

const data = [
    {
        question: 'Нужно ли подтверждать адрес электронной почты?',
        answer: 'Подтверждать адрес электронной почты не нужно',
    },
    {
        question: 'Как создать сет?',
        answer: 'Вы должны быть зарегистрированы и авторизованы. Выберите в меню «Создать», далее «Сет карточек». Вы должны заполнить минимум две карточки. Это требование системы. После заполнения необходимого количества карточек нажмите «Готово»',
    },
    {
        question: 'Как создать папку?',
        answer: 'Вы должны быть зарегистрированы и авторизованы. Выберите в меню «Создать», далее «Папка». Заполните необходимые поля и нажмите «Готово»',
    },
    {
        question: 'Как просмотреть список всех сетов или папок?',
        answer: 'Выберите в меню «Библиотека», перейдите на нужную вкладку и нажмите кнопку «Просмотреть все»',
    },
    {
        question: 'Как сменить вариант ответа?',
        answer: 'Выберите интересующий вас сет и режим обучения, далее нажмите на кнопку «Параметры» и выберите нужный вам вариант ответа',
    },
    {
        question: 'Как сменить изучаемые термины?',
        answer: 'Выберите интересующий вас сет и режим обучения, далее нажмите на кнопку «Параметры» и выберите вариант изучаемых терминов',
    },
    {
        question: 'Есть ли на сайте платные услуги?',
        answer: 'Платные услуги на сайте отсуствуют',
    },
];

const HelpPage = () => {
    return (
        <>
            <Typography
                sx={{
                    fontSize: [18, 21, 24, 27],
                    fontWeight: 700, mb: [3, 4, 5, 6],
                }}>Помощь</Typography>

            <Stack direction='column' spacing={5}>
                {
                    data.map(({ question, answer }) => {
                        return (
                            <Box key={question}>
                                <Typography sx={{ color: 'text.primary', fontSize: 21, fontWeight: 500, mb: 0.75, }}>
                                    {question}
                                </Typography>
                                <Typography sx={{ color: 'text.secondary', fontSize: 14, }}>{answer}</Typography>
                            </Box>
                        )
                    })
                }
            </Stack>
        </>
    );
};

export default HelpPage;